export enum CountryISO3 {
  AFG = 'AFG',
  ALB = 'ALB',
  AIA = 'AIA',
  ATA = 'ATA',
  DZA = 'DZA',
  ASM = 'ASM',
  VIR = 'VIR',
  AND = 'AND',
  AGO = 'AGO',
  ATG = 'ATG',
  ARG = 'ARG',
  ARM = 'ARM',
  ABW = 'ABW',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  ALA = 'ALA',
  BES = 'BES',
  BHS = 'BHS',
  BHR = 'BHR',
  BGD = 'BGD',
  BRB = 'BRB',
  BLR = 'BLR',
  BEL = 'BEL',
  BLZ = 'BLZ',
  BEN = 'BEN',
  BMU = 'BMU',
  BTN = 'BTN',
  BOL = 'BOL',
  BIH = 'BIH',
  BWA = 'BWA',
  BVT = 'BVT',
  BRA = 'BRA',
  IOT = 'IOT',
  VGB = 'VGB',
  CYM = 'CYM',
  CXR = 'CXR',
  CCK = 'CCK',
  COK = 'COK',
  FLK = 'FLK',
  FRO = 'FRO',
  GUF = 'GUF',
  PYF = 'PYF',
  ATF = 'ATF',
  GIB = 'GIB',
  GRL = 'GRL',
  GLP = 'GLP',
  GUM = 'GUM',
  GGY = 'GGY',
  HKG = 'HKG',
  IMN = 'IMN',
  JEY = 'JEY',
  XKX = 'XKX',
  MAC = 'MAC',
  MTQ = 'MTQ',
  MYT = 'MYT',
  MSR = 'MSR',
  NCL = 'NCL',
  PSE = 'PSE',
  NIU = 'NIU',
  NFK = 'NFK',
  MNP = 'MNP',
  PCN = 'PCN',
  PRI = 'PRI',
  REU = 'REU',
  BLM = 'BLM',
  SHN = 'SHN',
  MAF = 'MAF',
  SPM = 'SPM',
  BRN = 'BRN',
  BGR = 'BGR',
  BFA = 'BFA',
  BDI = 'BDI',
  CPV = 'CPV',
  KHM = 'KHM',
  CMR = 'CMR',
  CAN = 'CAN',
  CAF = 'CAF',
  TCD = 'TCD',
  CHL = 'CHL',
  CHN = 'CHN',
  COL = 'COL',
  COM = 'COM',
  COD = 'COD',
  COG = 'COG',
  CRI = 'CRI',
  CIV = 'CIV',
  HRV = 'HRV',
  CUB = 'CUB',
  CYP = 'CYP',
  CZE = 'CZE',
  CUW = 'CUW',
  DNK = 'DNK',
  DJI = 'DJI',
  DMA = 'DMA',
  DOM = 'DOM',
  ECU = 'ECU',
  EGY = 'EGY',
  SLV = 'SLV',
  GNQ = 'GNQ',
  ERI = 'ERI',
  EST = 'EST',
  SWZ = 'SWZ',
  ETH = 'ETH',
  FJI = 'FJI',
  FIN = 'FIN',
  FRA = 'FRA',
  GAB = 'GAB',
  GMB = 'GMB',
  GEO = 'GEO',
  DEU = 'DEU',
  GHA = 'GHA',
  GRC = 'GRC',
  GRD = 'GRD',
  GTM = 'GTM',
  GIN = 'GIN',
  GNB = 'GNB',
  GUY = 'GUY',
  HTI = 'HTI',
  HMD = 'HMD',
  HND = 'HND',
  HUN = 'HUN',
  ISL = 'ISL',
  IND = 'IND',
  IDN = 'IDN',
  IRN = 'IRN',
  IRQ = 'IRQ',
  IRL = 'IRL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JPN = 'JPN',
  JOR = 'JOR',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KIR = 'KIR',
  PRK = 'PRK',
  KOR = 'KOR',
  KWT = 'KWT',
  KGZ = 'KGZ',
  LAO = 'LAO',
  LVA = 'LVA',
  LBN = 'LBN',
  LSO = 'LSO',
  LBR = 'LBR',
  LBY = 'LBY',
  LIE = 'LIE',
  LTU = 'LTU',
  LUX = 'LUX',
  MDG = 'MDG',
  MWI = 'MWI',
  MYS = 'MYS',
  MDV = 'MDV',
  MLI = 'MLI',
  MLT = 'MLT',
  MHL = 'MHL',
  MRT = 'MRT',
  UMI = 'UMI',
  MUS = 'MUS',
  MEX = 'MEX',
  FSM = 'FSM',
  MDA = 'MDA',
  MCO = 'MCO',
  MNG = 'MNG',
  MNE = 'MNE',
  MAR = 'MAR',
  MOZ = 'MOZ',
  MMR = 'MMR',
  NAM = 'NAM',
  NRU = 'NRU',
  NPL = 'NPL',
  NLD = 'NLD',
  NZL = 'NZL',
  NIC = 'NIC',
  NER = 'NER',
  NGA = 'NGA',
  MKD = 'MKD',
  NOR = 'NOR',
  OMN = 'OMN',
  PAK = 'PAK',
  PLW = 'PLW',
  PAN = 'PAN',
  PNG = 'PNG',
  PRY = 'PRY',
  PER = 'PER',
  PHL = 'PHL',
  POL = 'POL',
  PRT = 'PRT',
  QAT = 'QAT',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  KNA = 'KNA',
  LCA = 'LCA',
  VCT = 'VCT',
  WSM = 'WSM',
  SMR = 'SMR',
  STP = 'STP',
  SAU = 'SAU',
  SEN = 'SEN',
  SRB = 'SRB',
  SYC = 'SYC',
  SLE = 'SLE',
  SGP = 'SGP',
  SXM = 'SXM',
  SVK = 'SVK',
  SVN = 'SVN',
  SLB = 'SLB',
  SOM = 'SOM',
  ZAF = 'ZAF',
  SGS = 'SGS',
  SSD = 'SSD',
  ESP = 'ESP',
  LKA = 'LKA',
  SDN = 'SDN',
  SUR = 'SUR',
  SJM = 'SJM',
  SWE = 'SWE',
  CHE = 'CHE',
  SYR = 'SYR',
  TWN = 'TWN',
  TJK = 'TJK',
  TZA = 'TZA',
  THA = 'THA',
  TLS = 'TLS',
  TGO = 'TGO',
  TKL = 'TKL',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TKM = 'TKM',
  TCA = 'TCA',
  TUV = 'TUV',
  UGA = 'UGA',
  UKR = 'UKR',
  ARE = 'ARE',
  GBR = 'GBR',
  USA = 'USA',
  URY = 'URY',
  UZB = 'UZB',
  VUT = 'VUT',
  VAT = 'VAT',
  VEN = 'VEN',
  VNM = 'VNM',
  WLF = 'WLF',
  ESH = 'ESH',
  YEM = 'YEM',
  ZMB = 'ZMB',
  ZWE = 'ZWE',
  PSX = 'PSX',
  /** @deprecated */
  YUG = 'YUG',
}
